<template>
  <div class="category-list">
    <!-- Title -->
    <h3 class="category-list__title" v-html="$i18n('blog.categories')" />
    <!-- ./Title -->
    <!-- Category List -->
    <div class="category-list__chips">
      <a
        v-for="(category, index) in categoryList"
        :key="`category-${index}`"
        :class="[
          'category-list__chips-item flex items-center',
          {
            active: isCategorySelected(category),
          },
        ]"
        :href="`/blog/${category.slug ? category.slug + '/' : ''}`"
        :aria-label="`category-${index}`"
      >
        {{ category.name }}
      </a>
    </div>
    <!-- ./Category List -->
  </div>
</template>
<script>
export default {
  name: 'CategoryList',
  props: {
    selectedCategory: {
      type: [String, Object],
      default: () => {},
    },
  },
  computed: {
    categoryList() {
      return this.$store.state.category.categories;
    },
  },
  methods: {
    isCategorySelected(category) {
      return category.id === this.selectedCategory?.id || (this.selectedCategory == null && category.id == null);
    },
  },
};
</script>
<style lang="scss">
.category-list {
  @apply md:container px-5 lg:px-0 md:px-0 mb-[30px] pt-[40px] md:pt-[80px];

  &__title {
    @apply text-[30px] font-cocogoose mb-[20px];
  }

  &__chips {
    @apply flex flex-row flex-wrap items-center gap-[10px] font-sans;

    &-item {
      @apply rounded-full duration-300 border border-[#979797] px-[20px] py-[10px] h-[44px] text-[16px] leading-[20px];

      &.active {
        @apply border-2 text-blue-500 border-blue-500 font-sans font-bold;
      }

      &:hover {
        @apply text-blue-500 border-blue-500;
      }
    }
  }
}
</style>
